import { createStore } from 'jotai';

const jotaiStore = createStore();

export default jotaiStore;
